define(
    'connections/product-connection',[
        'jquery',

        'utils/ajax-util',
        'utils/toast',

        'settings',
    ],

    function ($, ajax, toast, settings) {
        /**
         * @class ProductConnection
         */
        return (function () {

            /**
             * @constructor
             */
            function ProductConnection() { }

            ProductConnection.prototype.getProductData = function (pid, includeArticles, outlet) {
                return ajax.get(settings.productApiUrl + '/' + pid +
                    '?includeArticles=' + includeArticles +
                    '&outlet=' + outlet +
                    '&hash=' + settings.hash
                );
            };

            ProductConnection.prototype.loadStock = function (skus, refreshCache) {
                return $.ajax({
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    url: settings.articleStockList + '?hash=' + settings.hash + '&refreshCache=' + refreshCache,
                    traditional: true,
                    data: JSON.stringify(skus),
                    success: function (res) {
                        // Connection ok but something wrong with stock that we inform user of. 
                        if (res.status === "error") {
                            toast.queueError(res.message, 5000);
                        }
                    }
                });
            };

            /**
             * Get global stock of sku
             *
             * @param  {[type]} sku
             * @return {GlobalStockUtil}
             */
            ProductConnection.prototype.getGlobalStock = function (sku, callback) {
                if (sku === null)
                    return;

                return ajax.get(settings.articleGlobalStock.replace(':sku', sku));
            };

            ProductConnection.prototype.getProductImages = function (id) {
                return ajax.get(settings.productImagesApiUrl.replace(':id', id));
            };

            ProductConnection.prototype.getProductPriceView = function (productID) {
                return ajax.get(settings.productViewApiUrl + "/priceview" + '?id=' + productID);
            };

            ProductConnection.prototype.getCustomerPriceView = function (sku, inboxItems) {
                var params = $.param({sku: sku, inboxItems: inboxItems});
                return ajax.get(settings.productViewApiUrl + "/customerprice?" + params );
            };

            ProductConnection.prototype.getReplacementProductBoxView = function (productID) {
                return ajax.get(settings.productViewApiUrl + "/replacementproductview" + '?id=' + productID);
            };

            ProductConnection.prototype.saveAsPdf = function () {
                // body...
            };

            ProductConnection.prototype.getProductMatrixData = function (pid, outlet) {
                var data = {
                    outlet: outlet
                };

                return ajax.get(settings.matrixApiUrl.replace(':id', pid), data);
            };

            ProductConnection.prototype.getMatrixView = function (pid, outlet) {
                var data = {
                    outlet: outlet
                };

                return ajax.get(settings.matrixviewApiUrl.replace(':id', pid), data);
            };

            return new ProductConnection();
        })();
    }
);

